export default __webpack_public_path__ + "static/media/rw-l.750c9d5d.jpg";